import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subject } from 'rxjs';
import { CaseService } from '../../services/case.service';
import { LookupService } from '../../services/lookup.service';
import { SharedHttpService } from '../../services/shared-http.service';
import { InspectionService } from 'src/app/shared/services/inspection.service';

@Component({
    selector: 'app-general-attachment',
    templateUrl: './general-attachment.component.html',
    styleUrls: ['./general-attachment.component.scss']
})
export class GeneralAttachmentComponent implements OnInit {
    AttachmentId: any;
    otherTypeInfo: any;
    commitieId: any;
    CommitteeArr: any;
    inspectionDetails: any;
    constructor(private inspectionService: InspectionService,public caseService: CaseService, public lookupService: LookupService, private sanitizer: DomSanitizer, private sharedService: SharedHttpService) { }
    @Input() ElementTypeId: string;
    /* 1:مرفقات تحري
    2: مرفقات تفتيش
    3:مرفقات استدعاء
    4:مرفقات محضر
    5:مرفقات اجراءات خارجية
    6:مرفقات كشف حساب
     */
    BaseElementId: any;
    eCaseId: any;
    IsReadOnly: boolean = false;
    Loader: boolean = false;
    @Input() IsInspection: any = 'false';
    @Input() loadDataFP: Observable<any>;
    @Output() LengthData = new EventEmitter<any>();
    @Output() attachAdded = new EventEmitter<any>();
   

    attachmentList: any = [];
    doc: any = "";
    pdfFile = false;
    image: any;
    attachmentId: any;
    selectedFile: any;

    attachmentTypeId: any;

    description: string;
    incommingOrgName: string;
    atachTypesArr: any;
    isInsert: boolean = false;
    recordIdEdit: any;
    caseDetails: any;
    typeId: any;
    CaseAttachType: any;
    ngOnInit(): void {
        this.Loader = false;
        this.doc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
        this.loadDataFP.subscribe((data) => {
            this.BaseElementId = data.id;
            this.IsReadOnly = data.IsReadOnly;
            this.loadData();
        });
        this.caseDetails = this.caseService.getCaseData();
        this.inspectionDetails = this.inspectionService.getInspectionData();

        this.atachTypesArr = this.lookupService.getLockup('attachmenttypes');
        let atachTypesData = [];
        
        ///////////////////////////////////////////////////
        //if (this.inspectionDetails ) {
        //    this.atachTypesArr.map((el: any) => {
        //        if (el.more == "")
        //            atachTypesData.push(el);
        //    });
        //    this.atachTypesArr = [...atachTypesData];
        //}
        //else {


        if ((this.caseDetails && (this.caseDetails.isViolation != true || this.caseDetails.isViolation == null)) || this.IsInspection=='true') {
                this.atachTypesArr.map((el: any) => {
                    if (el.more == "")
                        atachTypesData.push(el);
                });
                this.atachTypesArr = [...atachTypesData];
            }

            else {
                this.atachTypesArr.map((el: any) => {
                    if (el.more != "")
                        atachTypesData.push(el);
                });
                this.atachTypesArr = [...atachTypesData];
            }
            
        //}

        ///////////////////////////////////////////////////////
        this.CommitteeArr = this.lookupService.getLockup('committees');

    }


    getAttachType(e) {
        this.commitieId=e.more;
    }
    //changeId(newelementId: any ,eCaseId:any) {  //this usered after save first time in parent compenent
    //    this.BaseElementId = newelementId;
    //    this.eCaseId = eCaseId;
    //}

    loadData() {
        let url = `api/Attachment/GetAttachmentsList?ElementTypeId=${this.ElementTypeId}&ElementId=${this.BaseElementId}`;
        this.sharedService.get(url).subscribe(res => {
            this.attachmentList = res;
            this.LengthData.emit(this.attachmentList.length);


        });
    }


    // attachment
    //GetAttachments() {
    //    let addUrl: any = `api/CaseRecord/GetAttachments?ecaseId=${this.eCaseId}&RecordId=${this.RecordId}`
    //    this.sharedService.get(addUrl).subscribe(result => {
    //        this.attachmentList = result;
    //    });
    //}
    upload(model) {
        this.attachmentTypeId = undefined;
        this.otherTypeInfo = undefined;
        this.incommingOrgName = undefined;
        this.description = undefined;

        this.sharedService.openSmall(model);
    }
    loadscanner: Subject<any> = new Subject<any>();

    isScan: boolean = false;
    scan(modal) {
        this.sharedService.openXLarge(modal);
        this.isScan = true;
        setTimeout(() => {
            this.loadscanner.next({});
        }, 100);

    }
    hidescan(modal) {
        this.isScan = false;
        modal.dismiss('Cross click');
        this.loadData();
    }
    checktype(name) {
        var ext = name.split('.').pop();

        if (ext == "doc"
            || ext == "docx"
            || ext == "xls"
            || ext == "xlsx"
            || ext == "ppt"
            || ext == "pptx"
            || ext == "png"
            || ext == "jpg"
            || ext == "jpeg"
            || ext == "tiff"
            || ext == "pdf"
            || ext == "svg"
            || ext == "bmp"
            || ext == "ico"
            || ext == "mp4" || ext == "avi" || ext == "mpeg" || ext == "dat" || ext == "mp3"

        )
            return true;
        else
            return false;
    }

    selectAttchmentType(id, file) {
        this.attachmentTypeId = id;
        file.click();
    }
    selectFile(file: any) {
        this.selectedFile = file;
    }

    UploadFile(modal) {
        this.Loader = true;
        if (!this.checktype(this.selectedFile.target.files[0].name)) {
            this.sharedService.showErrorKey("FileExtCheck");
            return;
        }
        let formData: FormData = new FormData();
        let url = "";
        formData.append('reportProgress', 'true');
        formData.append('observe', 'events');
        formData.append('file', this.selectedFile.target.files[0]);
        formData.append('attachmentTypeId', this.attachmentTypeId);
        formData.append('elementId', this.BaseElementId);
        formData.append('elementTypeId', this.ElementTypeId);
        formData.append('incommingOrgName', this.incommingOrgName);
        formData.append('otherTypeInfo', this.otherTypeInfo);
        formData.append('description', this.description);
        formData.append('attachmentTypeName', this.selectedFile.target.files[0].name);
        formData.append('ContentType', this.selectedFile.target.files[0].type);
        url = `api/Attachment/Upload`;
        this.sharedService.post(url, formData).subscribe(results => {
            modal.dismiss('Cross click');
            this.selectedFile = undefined;
            this.attachmentTypeId = undefined;
            this.sharedService.showSuccessKey("AttachmentUploadedSuccessfully");
            this.loadData();
            this.attachAdded.emit();
            this.Loader = false;

        });
    }


    downloadFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: attachment.mimeType });
        var url = window.URL.createObjectURL(blob);

        var fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.download = attachment.fileName;
        fileLink.click();
    }
    download(attachment) {
        let url = `api/Attachment/Download?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.downloadFile(data, attachment);
        });
    }
    previewPDF(attach, pdfmodal) {

        this.sharedService.openLarge(pdfmodal);
        this.show(attach);
    }
    show(attachment) {
        let url = `api/Attachment/Download?eAttachmnetId=${attachment.eAttachmentId}`;
        this.sharedService.downloadFileGet(url).subscribe(data => {
            this.ShowFile(data, attachment);
        });
    }
    ShowFile(data: any, attachment: any) {
        var blob = new Blob([data], { type: attachment.fileType });
        var url = window.URL.createObjectURL(blob);
        this.doc = url;
        if (attachment.fileName.endsWith('.pdf')) {
            this.pdfFile = true;
        } else {
            this.pdfFile = false;
            this.image = this.sanitizer.bypassSecurityTrustUrl(url)
        }
    }




    DeletePhisicalAttachment(AttachmentId, modal) {
        this.AttachmentId = AttachmentId;
        this.sharedService.openSmall(modal);
    }
    onDeletePhisicalAttach(modal) {
        let url = `api/Attachment/Delete`;
        this.sharedService.delete(url, [this.AttachmentId]).subscribe(res => {
            modal.dismiss('Cross click');
            if (res.length > 0)
                this.sharedService.showSuccessKey("DeletedSuccessfully");
            else
                this.sharedService.showErrorKey("ThisActionIsNotAllowed");
            this.loadData();
        });
    }



}
